import React, {PureComponent, MouseEvent, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'
import cxs from 'cxs/component'
import Store from '../Store'
import Theme from 'Theme'
import {Loading} from 'elements'
import {spinner} from 'elements/Loading'

interface Props {
  children: JSX.Element | string
  loading?: string | string[]
  primary?: boolean
  style?: object
  store?: Store
  onClick(): void
}

@inject('store')
@observer
class Button extends PureComponent<Props, object> {
  handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    this.props.onClick()
  }

  render() {
    const {children, onClick, loading, store, ...props} = this.props
    const isLoading = store!.UI.isLoading(loading)
    return (
      <StyledButton
        {...props}
        onClick={isLoading ? () => {} : this.handleClick}
        isLoading={isLoading}
        content={children}>
        <span>{children}</span>
      </StyledButton>
    )
  }
}

export default Button

const StyledButton = cxs('button')(
  ({content, primary, isLoading}) =>
    ({
      position: 'relative',
      ...typeof content === 'string'
        ? {padding: Theme.size.space[1]}
        : undefined,
      ...primary ? {color: Theme.color.primary} : undefined,
      ':hover': {
        color: Theme.color.primary
      },
      ...isLoading ? {'> span': {visibility: 'hidden'}, ...spinner} : undefined
    })
)

StyledButton.propTypes = {
  primary: PropTypes.bool,
  isLoading: PropTypes.bool
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Button.tsx